var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReset = function SvgReset(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 15 15",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#757B8A",
    d: "M9.981 3.658a5 5 0 0 0-.342.004H3.798l.889-.889a1.114 1.114 0 1 0-1.575-1.575L.319 3.989c-.231.233-.345.553-.313.832-.033.326.08.647.311.881l2.794 2.792A1.115 1.115 0 0 0 4.688 6.92L3.659 5.891l6.006-.001a2.885 2.885 0 0 1 3.109 3.011 2.89 2.89 0 0 1-3.128 2.996H2.504a1.113 1.113 0 0 0 0 2.225h7.13q.122.006.243.006c1.28 0 2.497-.47 3.45-1.34a5.1 5.1 0 0 0 1.672-3.891 5.135 5.135 0 0 0-5.018-5.239"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReset);
export default ForwardRef;